import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { Field } from 'src/app/tools/models/dtos/field';
import { RoleLovComponent } from '../../role/role-lov/role-lov.component';
import { GeoAreaLovComponent } from '../../../control-tables/geo-area-lov/geo-area-lov.component';
import { BranchLovComponent } from '../../../control-tables/branch/branch-lov/branch-lov.component';
import { PartnerAnalysisGroup1LovComponent } from '../../../control-tables/partner-analysis-group1-lov/partner-analysis-group1-lov.component';
import { PartnerAnalysisGroup2LovComponent } from '../../../control-tables/partner-analysis-group2-lov/partner-analysis-group2-lov.component';
import { PartnerAnalysisGroup3LovComponent } from '../../../control-tables/partner-analysis-group3-lov/partner-analysis-group3-lov.component';
import { PartnerAnalysisGroup4LovComponent } from '../../../control-tables/partner-analysis-group4-lov/partner-analysis-group4-lov.component';
import { PartnerAnalysisGroup5LovComponent } from '../../../control-tables/partner-analysis-group5-lov/partner-analysis-group5-lov.component';
import { PaymentTermLovComponent } from '../../../control-tables/payment-term-lov/payment-term-lov.component';
import { BankLovComponent } from '../../../control-tables/bank-lov/bank-lov.component';
import { ProductAttributeGroupLovComponent } from '../../../control-tables/product-attribute-group-lov/product-attribute-group-lov.component';
import { SalesChannelLovComponent } from '../../../control-tables/sales-channel-lov/sales-channel-lov.component';
import { PriceListLovComponent } from '../../product/price-list-lov/price-list-lov-.component';
import { ProductAttributeGroupParamLovComponent } from '../../../control-tables/product-attribute-group-pram-lov/product-attribute-group-param-lov.component';
import { ItineraryLovComponent } from '../itinerary-lov/itinerary-lov.component';
import { Currency } from 'src/app/assabil-kernel/models/entities/control-tables/currency';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { PartnerCategory } from 'src/app/assabil-kernel/models/entities/control-tables/partner-category-entity';
import { SalesChannel } from 'src/app/assabil-kernel/models/entities/control-tables/sales-channel';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { WarehouseLovComponent } from '../../../control-tables/branch/warehouse-lov/warehouse-lov.component';
import { PartnerPipe } from 'src/app/assabil-kernel/pipes/partner-pipe';

@Component({
  selector: 'partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss']
})


export class PartnerListComponent extends BasePage2<Partner>  {

  itineraryLovComponent = ItineraryLovComponent;
  //----------------------------------------------------------------------
  partnerPipe       : PartnerPipe = new PartnerPipe();
  //----------------------------------------------------------------------
  progressLevel     : any;

  code              : string;
  name              : string; 
  branchs           : Branch[];
  partnerCategorys  : PartnerCategory[];
  salesChannels     : SalesChannel[];
  currencys         : Currency[]


  branchCode        : string;
  itinerary         : Itinerary;

  salesChannelCode  : string;
  partnerCategoryCode : string;
  partnerStatusCode : string;




  partners          : Partner[] = [];
  showInMap         : boolean = false;


  constructor(
    protected masterDataService : MasterDataService,
    protected toastr            : ToastrService,
    protected baseService       : BaseService,
    protected leanUtilsService  : LeanUtilsService, 
    protected router            : Router,
    protected location          : Location,
    protected controlService    : ControlTablesService) {
      super(toastr, router,  baseService, leanUtilsService, location);

      this.entityName = 'partner';
  }

  // ---------------------------------------------------      
ngOnInit(): void {
    super.ngOnInit();

    this.controlService.getList("branch",         this.controlService.getRequest()).then(result => { 
      this.branchs = result;
    });

    this.controlService.getList("partnerCategory", this.controlService.getRequest()).then(result => { 
      this.partnerCategorys = result;
    });
    
    this.controlService.getList("salesChannel",   this.controlService.getRequest()).then(result => { 
      this.salesChannels = result;
    });

    this.controlService.getList("currency",       this.controlService.getRequest()).then(result => { 
      this.currencys = result;
    });
}
// ---------------------------------------------------

//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
  /*
      this.baseService.fieldsGet('formField').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'term.termCode') {
                  field.modal = TermLovComponent;
                }
            })

      }) 
      */
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  getRows(): Partner[] {
    return this.partners;
  }
//----------------------------------------------------------------------


  //----------------------------------------------------------------------
  loadFirstPage(){
    this.serverPageNumber =0;
    this.loadData()
  }

  loadData() {

    let progressLevelId : number = null;
    if (this.progressLevel) progressLevelId = this.progressLevel.id;
  
    let itineraryCode : string = null;
    if (this.itinerary) itineraryCode = this.itinerary.itineraryCode;
    this.masterDataService.partnersGet(this.code, this.branchCode, itineraryCode, this.name, this.salesChannelCode, this.partnerCategoryCode, this.partnerStatusCode, progressLevelId, this.serverPageNumber).then(result => {    
      this.partners = result.partners;
      if(this.serverPageNumber == 0){
        this.totalRowCount    = result.rowCount;
        this.serverPageCount  = result.serverPageCount;
      }
      this.buildPoints();
    }).catch(error => {
      this.showError(error);
    })
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let currency : Currency = new Currency();
  currency.currencyCode = "?";
  let partner : Partner = new Partner();
  partner.inserted        = true;
  partner.edit            = true;
  partner.rank            = 0;
  partner.currency        = currency;

  this.selectedRow = partner;

}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  selectRow(partner : Partner){ 
    //let index : number = this.partners.indexOf(partner);
    this.masterDataService.partnerGet(partner.partnerCode).then(result => {
      //this.partners[index] = result;
      this.selectedRow = result; 
      });
  }
//----------------------------------------------------------------------
  

//----------------------------------------------------------------------
  enrichField(field : Field){

    if (field.prop == 'currency') {
      field.lov =   {key : "currencyCode",  value : "name",  data : this.currencys } ;
      field.key = 'currencyCode';
      return;
  }

    if (field.prop == 'role') {
      field.modal = RoleLovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'geoArea') {
      field.modal = GeoAreaLovComponent;
      field.subProp = 'name';
      return;
    }
    
    if (field.prop == 'branch') {
      field.modal = BranchLovComponent;
      field.subProp = 'name';
      return;
    }
    
    if (field.prop == 'warehouse') {
      field.modal = WarehouseLovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'partnerAnalysisGroup1') {
      field.modal = PartnerAnalysisGroup1LovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'partnerAnalysisGroup2') {
      field.modal = PartnerAnalysisGroup2LovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'partnerAnalysisGroup3') {
      field.modal = PartnerAnalysisGroup3LovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'partnerAnalysisGroup4') {
      field.modal = PartnerAnalysisGroup4LovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'partnerAnalysisGroup5') {
      field.modal = PartnerAnalysisGroup5LovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'paymentTerm') {
      field.modal = PaymentTermLovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'salesChannel') {
      field.modal = SalesChannelLovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'priceList') {
      field.modal = PriceListLovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'bank') {
      field.modal = BankLovComponent;
      field.subProp = 'name';
      return;
    }

    if (field.prop == 'itinerary') {
      field.modal = ItineraryLovComponent;
      field.subProp = 'name';
      return;
    }
    
    if (field.prop == 'productAttributeGroup1') {
      field.modal = ProductAttributeGroupLovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'productAttributeGroup2') {
      field.modal = ProductAttributeGroupLovComponent;
      field.subProp = 'name';
      return;
    }
    if (field.prop == 'productAttributeGroupParam') {
      field.modal = ProductAttributeGroupParamLovComponent;
      field.subProp = 'name';
      return;
    }
  }
//----------------------------------------------------------------------
  




//----------------------------------------------------------------------
  map(show : boolean){
    if (show){
   //   this.buildPoints();
    }
    this.showInMap = show;
  }

  points : marker[] = [];
  buildPoints(){
  //  this.pointEs : Marker[this.branchs.length];
    let i : number = 0;
    this.partners.forEach(partner => {

      let point : marker = {     
        lat: partner.latitude,
        lng: partner.longitude,
        label: partner.name,
        draggable: false,
        iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
      };
    
      this.points.push(point);
    })
  }

  distance(){}
  //----------------------------------------------------------------------
  
}
